<template>
  <div class="q-pb-md">

<!--    <div v-if="settings.theme.input.sublabel"  class="text-body2 mw-form-v2-label-padding" v-html="field.label"></div>-->

    <div class="flex justify-between"  v-if="!this.field.options.hide_min_max">
    <q-badge  class="mw-form-v2-linear-slider-label-badge" outline color="secondary">
      {{ this.unit(this.field.options.min) }}
    </q-badge>
    <q-badge  class="mw-form-v2-linear-slider-label-badge" outline color="secondary">
      {{ this.unit(this.field.options.max) }}
    </q-badge>
    </div>
<!--    :marker-labels="arrayMarkerLabel"-->

    <q-range
      v-if="fieldValue"
      v-model="fieldValue"
      class="mw-form-v2-linear-slider"
      label-always
      snap
      :left-label-value="itemlabel"
      :right-label-value="itemlabelRight"
      switch-label-side
      switch-marker-labels-side
      :min="parseFloat(field.options.min)"
      :max="parseFloat(field.options.max)"
      :step="parseFloat(field.options.step)"
      debounce="1000"
  />
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      // arrayMarkerLabel: [
      //   {
      //     value: this.field.options.min,
      //     label: this.field.options.suffix ? this.format(this.field.options.min) + this.field.options.unit : this.field.options.unit + this.format(this.field.options.min)
      //   },
      //   { value: this.field.options.max, label: this.field.options.suffix ? this.format(this.field.options.max) + this.field.options.unit : this.field.options.unit + this.format(this.field.options.max) }
      // ]
    };
  },
  emits: ['update:modelValue'],
  methods: {
    format(val) {
        return parseFloat(val).toLocaleString('en-US')
    },
    unit(val) {
      return this.field.options.suffix ? this.format(val) + this.field.options.unit : this.field.options.unit + this.format(val);
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    itemlabel: function () {
      return this.field.options.suffix ? this.format(this.fieldValue.min) + this.field.options.unit : this.field.options.unit + this.format(this.fieldValue.min);
    },
    itemlabelRight: function () {
      return this.field.options.suffix ? this.format(this.fieldValue.max) + this.field.options.unit : this.field.options.unit + this.format(this.fieldValue.max);
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      this.fieldValue =
      {
        min: parseFloat(this.field.options.value),
        max: this.field.options.valueNext ? parseFloat(this.field.options.valueNext) :  parseFloat(this.field.options.value) + parseFloat(this.field.options.step)
      };
  }
}
</script>
